import { tweenPromise, tweenWaitPromise } from '@Animation/utils'
import { CYBER_SNAKES_ATLAS_FRAMES, CYBER_SNAKES_TEXTURE_KEYS } from './constants'

export class CyberSnake extends Phaser.GameObjects.Container {
  private container: Phaser.GameObjects.Container
  private head: Phaser.GameObjects.Image
  private particleEmitter: Phaser.GameObjects.Particles.ParticleEmitter

  constructor(scene: Phaser.Scene, x: number, y: number, scale: number = 1) {
    super(scene, x, y)

    this.container = this.scene.add.container(0, 0)

    this.head = this.scene.add.image(
      -1000,
      -1000,
      CYBER_SNAKES_TEXTURE_KEYS.ATLAS,
      CYBER_SNAKES_ATLAS_FRAMES.PROJECTILE_1,
    )
    this.head.setScale(scale)
    this.head.setOrigin(0.5, 0.5)

    const startColor = Phaser.Display.Color.ValueToColor(0xb5fff5)
    const endColor = Phaser.Display.Color.ValueToColor(0xc3fff7)

    this.particleEmitter = this.scene.add.particles(0, 0, CYBER_SNAKES_TEXTURE_KEYS.ATLAS, {
      frame: CYBER_SNAKES_ATLAS_FRAMES.PARTICLE_TRAIL,
      x: 0,
      y: 0,
      speed: 0,
      scale: { start: scale, end: 0.9 * scale },
      alpha: { values: [0.1, 0], ease: Phaser.Math.Easing.Circular.Out },
      lifespan: 500,
      blendMode: 'NORMAL',
      frequency: 1,
      tint: {
        onUpdate: (particle: Phaser.GameObjects.Particles.Particle) => {
          const index = 100 * particle.lifeT

          const colorObj = Phaser.Display.Color.Interpolate.ColorWithColor(
            startColor,
            endColor,
            100,
            index,
          )

          return Phaser.Display.Color.GetColor(colorObj.r, colorObj.g, colorObj.b)
        },
      },
    })

    this.particleEmitter.stop()
    this.container.add(this.head)
    this.add([this.particleEmitter, this.container])
  }

  setSnakePosition(x: number, y: number) {
    this.head.setPosition(x, y)
  }

  highlightSnake() {
    this.head.setTexture(CYBER_SNAKES_TEXTURE_KEYS.ATLAS, CYBER_SNAKES_ATLAS_FRAMES.PROJECTILE_2)
  }

  standardSnake() {
    this.head.setTexture(CYBER_SNAKES_TEXTURE_KEYS.ATLAS, CYBER_SNAKES_ATLAS_FRAMES.PROJECTILE_1)
  }

  async moveSnake(x: number, y: number, duration: number) {
    await tweenPromise(this.scene, {
      targets: this.head,
      x: x,
      y: y,
      duration: duration,
    })()
  }

  startMovement() {
    this.head.setTexture(CYBER_SNAKES_TEXTURE_KEYS.ATLAS, CYBER_SNAKES_ATLAS_FRAMES.PROJECTILE_1)
    this.setVisible(true)
    this.head.setAlpha(1)
    this.particleEmitter.start()
    this.particleEmitter.startFollow(this.head)
  }

  async stopMovement() {
    this.particleEmitter.stop()
    this.particleEmitter.stopFollow()

    const frameDur = 32

    this.head.setTexture(CYBER_SNAKES_TEXTURE_KEYS.ATLAS, CYBER_SNAKES_ATLAS_FRAMES.PROJECTILE_2)
    await tweenWaitPromise(this.scene, frameDur)()
    this.head.setTexture(CYBER_SNAKES_TEXTURE_KEYS.ATLAS, CYBER_SNAKES_ATLAS_FRAMES.PULSE_0)
    await tweenWaitPromise(this.scene, frameDur)()
    this.head.setTexture(CYBER_SNAKES_TEXTURE_KEYS.ATLAS, CYBER_SNAKES_ATLAS_FRAMES.PULSE_1)
    await tweenWaitPromise(this.scene, frameDur)()
    this.head.setTexture(CYBER_SNAKES_TEXTURE_KEYS.ATLAS, CYBER_SNAKES_ATLAS_FRAMES.PULSE_2)
    await tweenWaitPromise(this.scene, frameDur)()
    this.head.setTexture(CYBER_SNAKES_TEXTURE_KEYS.ATLAS, CYBER_SNAKES_ATLAS_FRAMES.PULSE_3)

    this.hide()
  }

  async hide() {
    await tweenPromise(this.scene, {
      targets: this.head,
      alpha: 0,
      duration: 200,
    })()

    this.setVisible(false)
  }
}
